import { lazy } from 'react';

export const LazyChooseSignupPlanPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--choose-signup-plan-page" */ './choose-signup-plan-page'
    ),
);
